import { useCallback, useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import SafeImage from '../../components/BasicComponent/SafeImage'
import { TRAFFIC_FINE_BENEFITS } from '../../components/FeatureComponent/RegisteredPackageInfo'
import quanLyDangKyBannerLanDau from '../../assets/images/quanlydangki_bannerlandau.png'
import { PATH } from '../../constants/router'
import { useAppUserContext } from '../../context/AppUserContext'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import {
  getTrafficFineRegistrationManagementUserKey,
  hasSeenTrafficFineRegistrationManagementFirstTime,
  markTrafficFineRegistrationManagementFirstTimeAsSeen
} from '../TrafficFineRegistrationManagement/storage'
import bidvRegistrationNotificationBanner from '../../assets/images/bidv_registration_notification_banner.png'
import { useAppParamsContext } from '../../context/AppParamsContext'
import useThemeFeatureConfig from '../../hooks/common/useThemeFeatureConfig'
import './index.scss'

const FIRST_TIME_BENEFIT_KEYS = ['12', '14', '13']

export default function TrafficFineRegistrationManagementFirstTime() {
  const history = useHistory()
  const location = useLocation()
  const { userData } = useAppUserContext()
  const { firstTimeBannerVariant = 1 } = useThemeFeatureConfig('TRAFFIC_FINE_REGISTRATION_MANAGEMENT')

  const registrationBanner = firstTimeBannerVariant === 2
    ? bidvRegistrationNotificationBanner
    : quanLyDangKyBannerLanDau
  const goToRegistrationManagement = useCallback(() => {
    history.goBack()
  }, [history])
  const firstTimeBenefits = useMemo(() => {
    return FIRST_TIME_BENEFIT_KEYS.map((benefitKey) =>
      TRAFFIC_FINE_BENEFITS.find((benefit) => String(benefit.key) === benefitKey)
    )
      .filter(Boolean)
      .map((benefit) => ({
        key: benefit.key,
        iconSrc: benefit.icon || benefit.icon,
        text: benefit.textIntro || benefit.text
      }))
  }, [])
  const trafficFineRegistrationManagementUserKey = useMemo(
    () =>
      getTrafficFineRegistrationManagementUserKey({
        phoneNumber: userData?.phoneNumberWithUsernamePrefix || location.state?.phoneNumber
      }),
    [location.state?.phoneNumber, userData?.phoneNumberWithUsernamePrefix]
  )
  const hasSeenFirstTime = hasSeenTrafficFineRegistrationManagementFirstTime(trafficFineRegistrationManagementUserKey)

  useEffect(() => {
    if (hasSeenFirstTime) {
      goToRegistrationManagement()
      return
    }

    markTrafficFineRegistrationManagementFirstTimeAsSeen(trafficFineRegistrationManagementUserKey)
  }, [goToRegistrationManagement, hasSeenFirstTime, trafficFineRegistrationManagementUserKey])

  const handleNextStep = () => {
    history.push({
      pathname: PATH.TRAFFIC_FINE_SERVICES,
      search: location.search,
      state: location.state
    })
  }

  if (hasSeenFirstTime) {
    return null
  }

  return (
    <LayoutPartner noBackground onGoBack={goToRegistrationManagement}>

      <div className="TrafficFineRegistrationManagementFirstTime">
        <div className="TrafficFineRegistrationManagementFirstTime_banner">
          <SafeImage src={registrationBanner} />
        </div>

        <div className="TrafficFineRegistrationManagementFirstTime_content">
          <div className="TrafficFineRegistrationManagementFirstTime_title">Đăng ký thông báo tự động</div>

          <div className="TrafficFineRegistrationManagementFirstTime_benefits">
            {firstTimeBenefits.map((benefit) => {
              return (
                <div key={benefit.key} className="TrafficFineRegistrationManagementFirstTime_benefitItem">
                  <div className="TrafficFineRegistrationManagementFirstTime_benefitIcon">
                    {typeof benefit.iconSrc === 'string' ? (
                      <SafeImage src={benefit.iconSrc} aria-hidden="true" className="TrafficFineRegistrationManagementFirstTime_benefitIconSvg" />
                    ) : (
                      <benefit.iconSrc aria-hidden="true" className="TrafficFineRegistrationManagementFirstTime_benefitIconSvg" />
                    )}
                  </div>
                  <div className="TrafficFineRegistrationManagementFirstTime_benefitText">{benefit.text}</div>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <FixedBottom elementPaddingBottom="LayoutPartner">
        <BaseButton onClick={handleNextStep}>Tiếp theo</BaseButton>
      </FixedBottom>
    </LayoutPartner>
  )
}

